// The catch-all route's NAME, shared by every router that has one and by the
// code that must tell « matched only the catch-all » from a real route (a push
// deep-link: a path the app does not have resolves to the catch-all, which
// would otherwise read as a match and silently land on Home).
export const NOT_FOUND_ROUTE = 'not-found'

/** The resolved location matched a real route, not just the catch-all. */
export function isRealRoute(resolved: { matched: readonly unknown[]; name?: unknown }): boolean {
  return resolved.matched.length > 0 && resolved.name !== NOT_FOUND_ROUTE
}
